// src/lib/spinAudio.js
// Synthesized sound effects for the /spin wheel via Web Audio — no audio
// assets to host, and it keeps every click/chime perfectly in sync with
// values already computed in JS (tick timing, win moment).

let ctx = null;

// AudioContext must be created/resumed from a user-gesture handler (the
// spin tap qualifies) or browsers will keep it suspended and silent.
function getContext() {
    if (typeof window === 'undefined') return null;
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return null;
    if (!ctx) ctx = new AudioContextClass();
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
}

let muted = false;
export function setSpinAudioMuted(value) {
    muted = value;
}

// A short mechanical "tick" — like a roulette pointer flicking past a peg.
// Pitch/volume jitter slightly so a run of ticks doesn't sound robotic.
export function playSpinTick(intensity = 1) {
    if (muted) return;
    const audio = getContext();
    if (!audio) return;

    const now = audio.currentTime;
    const osc = audio.createOscillator();
    const gain = audio.createGain();

    const pitch = 1400 + (Math.random() - 0.5) * 160;
    osc.type = 'square';
    osc.frequency.setValueAtTime(pitch, now);

    const peakVolume = 0.05 + intensity * 0.05;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(peakVolume, now + 0.002);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.03);

    osc.connect(gain).connect(audio.destination);
    osc.start(now);
    osc.stop(now + 0.035);
}

// A bright ascending chime for the win reveal.
export function playWinChime() {
    if (muted) return;
    const audio = getContext();
    if (!audio) return;

    const now = audio.currentTime;
    const notes = [523.25, 659.25, 783.99, 1046.5]; // C5 E5 G5 C6

    notes.forEach((freq, i) => {
        const start = now + i * 0.09;
        const osc = audio.createOscillator();
        const gain = audio.createGain();

        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, start);

        gain.gain.setValueAtTime(0.0001, start);
        gain.gain.exponentialRampToValueAtTime(0.12, start + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.5);

        osc.connect(gain).connect(audio.destination);
        osc.start(start);
        osc.stop(start + 0.55);
    });
}
